import { TransactionSuccessToast } from "@/components";
import { TOKEN_IDS, type TransactionHash } from "@/types";
import { ToastDetailRow } from "@/components";

interface WithdrawSuccessToastProps {
    withdrawAmount: number;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function WithdrawSuccessToast({ withdrawAmount, transactionHash, onClose }: WithdrawSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Withdrawal successful" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Withdrawn" amount={withdrawAmount} tokenId={TOKEN_IDS.IUSD} />
        </TransactionSuccessToast>
    );
}
